import {
  SET_ANREDE,
  SET_VORNAME,
  SET_NAME,
  SET_GEBURTSDATUM,
  SET_TELEFONNUMMER,
  SET_MAILADRESSE,
  SET_ADR_STRASSE,
  SET_ADR_STRASSENR,
  SET_ADR_PLZ,
  SET_ADR_ORT,
  SET_ADR_LAND,
  SET_BENACHRICHTIGUNGEN,
  SET_FREITEXT,
  SET_AGB,
  SET_BESTANDSPATIENT,
  SET_HASHED_ID
} from "./mutations.type";


export default {
  namespaced: true,
  state: {
    patient_hash: null,
    bestandspatient: null,
    anrede: null,
    vorname: null,
    name: null,
    geburtsdatum: null,
    adr_strasse: null,
    adr_strassenr: null,
    adr_plz: null,
    adr_ort: null,
    adr_land: null,
    telefonnummer: null,
    mailadresse: null,
    freitext: null,
    benachrichtigungen: false,
    agb: false,
  },
  mutations: {
    [SET_HASHED_ID](state, val) {
      state.patient_hash = val
      state.bestandspatient = true;
    },
    [SET_BESTANDSPATIENT](state, data) {
      state.bestandspatient = data;
    },
    [SET_ANREDE](state, data) {
      state.anrede = data;
    },
    [SET_VORNAME](state, data) {
      state.vorname = data;
    },
    [SET_NAME](state, data) {
      state.name = data;
    },
    [SET_ADR_STRASSE](state, data) {
      state.adr_strasse = data;
    },
    [SET_ADR_STRASSENR](state, data) {
      state.adr_strassenr = data;
    },
    [SET_ADR_PLZ](state, data) {
      state.adr_plz = data;
    },
    [SET_ADR_ORT](state, data) {
      state.adr_ort = data;
    },
    [SET_ADR_LAND](state, data) {
      state.adr_land = data;
    },
    [SET_GEBURTSDATUM](state, data) {
      state.geburtsdatum = data;
    },
    [SET_TELEFONNUMMER](state, data) {
      state.telefonnummer = data;
    },
    [SET_MAILADRESSE](state, data) {
      state.mailadresse = data;
    },
    [SET_FREITEXT](state, val) {
      state.freitext = val;
    },
    [SET_BENACHRICHTIGUNGEN](state, data) {
      state.benachrichtigungen = data;
    },
    [SET_AGB](state, data) {
      state.agb = data;
    },
  },
  actions: {
    clear({commit, state}) {
      commit(SET_VORNAME, null);
      commit(SET_NAME, null);
      commit(SET_GEBURTSDATUM, null);
      commit(SET_ADR_STRASSE, null);
      commit(SET_ADR_STRASSENR, null);
      commit(SET_ADR_PLZ, null);
      commit(SET_ADR_ORT, null);
      commit(SET_ADR_LAND, null);
      commit(SET_TELEFONNUMMER, null);
      commit(SET_MAILADRESSE, null);
      commit(SET_AGB, false);


      if(!state.patient_hash) commit(SET_BESTANDSPATIENT, null);

      commit(SET_ANREDE, null);
    }
  }
}
